var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.1665V14.1665L9.16667 12.4998",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 14.1667L5.83325 12.5",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 8.33317V12.4998C18.3334 16.6665 16.6667 18.3332 12.5001 18.3332H7.50008C3.33341 18.3332 1.66675 16.6665 1.66675 12.4998V7.49984C1.66675 3.33317 3.33341 1.6665 7.50008 1.6665H11.6667",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 8.33317H15.0001C12.5001 8.33317 11.6667 7.49984 11.6667 4.99984V1.6665L18.3334 8.33317Z",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBillIcon);
export default __webpack_public_path__ + "static/media/download-bill-icon.3b5623171def7f3f886284ea854412a5.svg";
export { ForwardRef as ReactComponent };